import * as React from 'react';
import styled from 'styled-components';
import { superLightGreyColour, tabletPortraitMinWidth } from '../../cssConstants';

const PageTitle = ({ title, subtitle, className }: Props) => {
	return (
		<TitleWrapper className={className}>
			<Title>{title}</Title>
			{subtitle && <SubTitle>{subtitle}</SubTitle>}
		</TitleWrapper>
	);
};

export default PageTitle;

interface Props {
	title?: string;
	subtitle?: string;
	className?: string;
}

export const TitleWrapper = styled.div`
	padding-top: 10px;
`;

export const Title = styled.p`
	font-size: 24px;
	font-weight: 400;
	line-height: 32px;
	color: ${(props) => props.theme.brandingColourHeavy};

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 28px;
	}
`;

export const SubTitle = styled.p`
	font-size: 14px;
	font-weight: 400;
	line-height: 20px;
	padding-top: 10px;
	color: ${superLightGreyColour};

	@media (min-width: ${tabletPortraitMinWidth}) {
		font-size: 16px;
	}
`;
